// Turn a data: URL into a Blob, without a network request.
//
// The obvious one-liner — `await (await fetch(dataUrl)).blob()` — is a trap
// here. It works locally but this app ships a Content Security Policy of
//
//   connect-src 'self' https://*.supabase.co wss://*.supabase.co
//
// and fetch() on a data: URL counts as a connection, so CSP blocks it with
// "Refused to connect". The signature pad hands back a PNG data URL, so
// uploading a signature failed with "Failed to fetch" under CSP even though
// nothing was actually being fetched from anywhere.
//
// Decoding the base64 ourselves involves no connection at all, so there is
// nothing for CSP to refuse.
export function dataUrlToBlob(dataUrl) {
  const str = String(dataUrl || '');
  const comma = str.indexOf(',');
  if (!str.startsWith('data:') || comma === -1) {
    throw new Error('Not a data URL.');
  }
  const header = str.slice(5, comma);          // e.g. "image/png;base64"
  const payload = str.slice(comma + 1);
  const mime = header.split(';')[0] || 'application/octet-stream';
  // Non-base64 data URLs are percent-encoded text.
  if (!/;base64/i.test(header)) {
    return new Blob([decodeURIComponent(payload)], { type: mime });
  }
  const binary = atob(payload);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}
